import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFolderForInvitesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetFolderForInvitesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename?: 'AudioAsset', id: string, name: string } | { __typename?: 'DocumentAsset', id: string, name: string } | { __typename?: 'FileAsset', id: string, name: string } | { __typename?: 'FolderAsset', restricted?: boolean | null, id: string, name: string } | { __typename?: 'ImageAsset', id: string, name: string } | { __typename?: 'InteractiveAsset', id: string, name: string } | { __typename?: 'InteractiveLiveAsset', id: string, name: string } | { __typename?: 'ModelAsset', id: string, name: string } | { __typename?: 'UnsupportedAsset', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string } | { __typename?: 'VideoAsset', id: string, name: string } | null } | null };


export const GetFolderForInvites = /*#__PURE__*/ gql`
    query GetFolderForInvites($id: ID!) {
  account(by: {assetId: $id}) {
    id
    asset(id: $id) {
      id
      name
      ... on FolderAsset {
        restricted
      }
    }
  }
}
    ` as unknown as DocumentNode<GetFolderForInvitesQuery, GetFolderForInvitesQueryVariables>;

          

          export const useGetFolderForInvitesQuery = (options?:QueryHookOptions<GetFolderForInvitesQuery, GetFolderForInvitesQueryVariables>) => useQuery(GetFolderForInvites, options);

          

          export type GetFolderForInvitesQueryOptions = QueryHookOptions<GetFolderForInvitesQuery, GetFolderForInvitesQueryVariables>;

          

          export const useGetFolderForInvitesLazyQuery = (options?:LazyQueryHookOptions<GetFolderForInvitesQuery, GetFolderForInvitesQueryVariables>) => useLazyQuery(GetFolderForInvites, options);

          

          export type GetFolderForInvitesQueryResult = ReturnType<typeof useGetFolderForInvitesQuery>;

          
